import React, { useState } from "react";
import * as MUI from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import EmailPlusIcon from "../../../../../icons/EmailPlus";
import { AddSubscriptionDialog } from "../../../../subscriptions/components";

import { useStyles } from "./Subscription.styles";
import { SubscriptionItemType } from "../../../../subscriptions/types";

import { useSubscriptionProviderContext } from "../../../shared";

export const Subscription: React.FC = () => {
  const {
    state: { currentPayload, isSubscriptionLoading, isSubscriptionDisabled },
  } = useSubscriptionProviderContext();

  const classes = useStyles();
  const [addSubscriptionDialogOpen, setAddSubscriptionDialog] = useState(false);

  if (isSubscriptionLoading) {
    return <Skeleton className={classes.root} variant="circle" width={48} height={48} />;
  }

  return (
    <>
      <MUI.IconButton
        className={classes.root}
        aria-label="Subscription"
        disabled={isSubscriptionDisabled}
        onClick={() => setAddSubscriptionDialog(true)}
      >
        <EmailPlusIcon className={classes.icon} />
      </MUI.IconButton>
      {currentPayload && (
        <AddSubscriptionDialog
          type={SubscriptionItemType.Slide}
          payload={currentPayload}
          open={addSubscriptionDialogOpen}
          handleCloseDialog={() => setAddSubscriptionDialog(false)}
        />
      )}
    </>
  );
};
